import { render, staticRenderFns } from "./ViewChargeCode.vue?vue&type=template&id=bc54332c"
import script from "./ViewChargeCode.vue?vue&type=script&lang=js"
export * from "./ViewChargeCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports